import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { UtilServico } from '../servicos/util.servico';
import { Router, ActivatedRoute } from '@angular/router';
import { Console } from '@angular/core/src/console';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { DatePipe, registerLocaleData } from '@angular/common';
import { NativeDateAdapter, NativeDateModule, DateAdapter, MatCalendar, MAT_DATE_FORMATS, MatDatepickerInputEvent, MAT_DATE_LOCALE } from '@angular/material';
import { CurrencyMaskModule } from "ngx-currency-mask";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ngx-currency-mask/src/currency-mask.config";
import { FormControl, FormsModule, NgForm, FormBuilder, FormGroup, Validators, FormGroupDirective } from "@angular/forms";
import { ErrorStateMatcher } from '@angular/material/core';
import { ResponseContentType } from '@angular/http';
import { saveAs } from 'file-saver/FileSaver';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Moment } from 'moment';
import * as moment from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { ConfigApi } from '../shared/config-api.model';
import { HttpClient } from '@angular/common/http';
import { ConfigUrlProvider } from '../shared/configurl-provider';
import swalAlert from 'sweetalert2';
import { log } from 'console';  


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: "."
};

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },

};

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export function matchValidator(fieldName: string) {
  let fcfirst: FormControl;
  let fcSecond: FormControl;

  return function matchValidator(control: FormControl) {

    if (!control.parent) {
      return null;
    }

    // INITIALIZING THE VALIDATOR.
    if (!fcfirst) {
      //INITIALIZING FormControl first
      fcfirst = control;
      fcSecond = control.parent.get(fieldName) as FormControl;

      //FormControl Second
      if (!fcSecond) {
        throw new Error('matchValidator(): Second control is not found in the parent group!');
      }

      fcSecond.valueChanges.subscribe(() => {
        fcfirst.updateValueAndValidity();
      });
    }

    if (!fcSecond) {
      return null;
    }

    if (fcSecond.value !== fcfirst.value) {
      return {
        matchOther: true
      };
    }

    return null;
  }
}

export class MyDateAdapter extends NativeDateAdapter {

  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } else {
      return date.toDateString();
    }
  }
}

declare var swal: any;
declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-inicial',
  templateUrl: './inicial.component.html',
  styleUrls: ['./inicial.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe, { provide: DateAdapter, useClass: MyDateAdapter },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ]
})
export class InicialComponent implements OnInit {
  userForm: FormGroup;
  password = 'password';
  configuracoes: any;
  pesquisar: any;
  Placar: any;
  DADOS: any;
  DADOS2: any;
  isValidarCC: any;
  isValidarRedimento: any;
  isValidaNotificacao: any;
  SENHA: any;
  TotalRegistro: number;
  PaginaAtual: number = 1;
  PaginaTotal: number = 25;
  Mostrar: any;
  DADOSSIMULACAO: any;
  DADOSSIMULACAOESPONTANEA: any;
  DADOSPESSOAIS: any;
  DADOSRENDIMENTOS: any;
  FAQ_PERGUNTA: any;
  EXPLICACAOREGRA: any;
  HABILITAR_AGENDAMENTO: any;
  EXPLICACAOREGRAEXPONTANEA: any;
  ABONO_PERMANENCIA: any;
  public DADOCONTRIB: any;
  public DADOHOLERITE: any;
  public DADOSFICHA: any;
  public parametros: any;
  //public sub = "http://localhost:62195/api/Inicial/";
  //public sub = "https://segurado.amprev.ap.gov.br/webapiportalestados/api/Inicial/";
  //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipe/api/Inicial/";
  private sub: any;
  private subSisprev: any;
  uf = [];
  cidades = [];
  segurados = [];  
  nacionalidade = [];  
  raca = [];
  FALE: any;
  assunto = [];
  FAQ = [];
  FAQ_PERGUNTAS = [];
  BOLETOS_PORTAL = [];
  PARAMETROS_AGENDAMENTO: any;
  AGENDAR_RECADASTRAMENTO: any;
  RESUMO_AGENDAMENTO: any;
  DADOS_CEDENTE_BOLETO: any;
  minDate: any;
  maxDate: any;
  startDate: any;
  private config: any;
  public sexo: Array<Object> = [
    { ID: 'M', NOME: 'Masculino' },
    { ID: 'F', NOME: 'Feminino' }
  ];
  public estadocivil: Array<Object> = [
    { ID: 0, NOME: 'SOLTEIRO(A)' },
    { ID: 1, NOME: 'CASADO(A)' },
    { ID: 2, NOME: 'VIÚVO(A)' },
    { ID: 3, NOME: 'DIVORCIADO(A)' },
    { ID: 4, NOME: 'DESQUITADO(A)' },
    { ID: 5, NOME: 'AMASIADO(A)' },
    { ID: 6, NOME: 'OUTROS(A)' },
    { ID: 7, NOME: 'UNIÃO ESTÁVEL' },
    { ID: 8, NOME: 'SEPARADO JUDICIALMENTE' }
  ];
  public apos: Array<Object> = [
    { ID: 'S', NOME: 'Sim - Professor' },
    { ID: 'N', NOME: 'Não' }
  ];
  public mes: Array<Object> = [
    { ID: 1, NOME: 'Janeiro' },
    { ID: 2, NOME: 'Fevereiro' },
    { ID: 3, NOME: 'Março' },
    { ID: 4, NOME: 'Abril' },
    { ID: 5, NOME: 'Maio' },
    { ID: 6, NOME: 'Junho' },
    { ID: 7, NOME: 'Julho' },
    { ID: 8, NOME: 'Agosto' },
    { ID: 9, NOME: 'Setembro' },
    { ID: 10, NOME: 'Outubro' },
    { ID: 11, NOME: 'Novembro' },
    { ID: 12, NOME: 'Dezembro' },
  ];
  public logradouro: Array<Object> = [
    { ID: 8, NOME: 'Avenida' },
    { ID: 81, NOME: 'Rua' },
    { ID: 100, NOME: 'Travessa' },
    { ID: 77, NOME: 'Quadra' },
    { ID: 65, NOME: 'Praça' },
    { ID: 104, NOME: 'Vila' },
    { ID: 4, NOME: 'Alameda' },
    { ID: 31, NOME: 'Estrada' },
    { ID: 90, NOME: 'Rodovia' },
    { ID: 105, NOME: 'Assentamento' },
    { ID: 106, NOME: 'Condomínio' },
    { ID: 107, NOME: 'Conjunto' },
    { ID: 108, NOME: 'Distrito' },
    { ID: 109, NOME: 'Fazenda' },
    { ID: 110, NOME: 'Jardim' },
    { ID: 111, NOME: 'Loteamento' },
    { ID: 112, NOME: 'Parque' },
    { ID: 113, NOME: 'Povoado' },
    { ID: 114, NOME: 'Sítio' },
  ];

  public declarante: Array<Object> = [
    { ID: '1', NOME: 'Segurado(a)' },
    { ID: '2', NOME: 'Curador(a)' },
    { ID: '3', NOME: 'Tutor(a)' },
    { ID: '4', NOME: 'Procurador(a)' }
  ];

  public periodo: Array<Object> = [
    { ID: 'M', NOME: 'Matutino' },
    { ID: 'V', NOME: 'Vespertino' },
  ];

  selectedAssunto: any;
  selectedAssuntoId: any;
  public resultados = [];
  FormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  matcher = new MyErrorStateMatcher();
  configApi: ConfigApi;

  constructor(private fBuilder: FormBuilder,
    private http: Http,
    private httpClient: HttpClient,
    private LoginServico: LoginServico,
    private UtilServico: UtilServico,
    private router: Router,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<MyDateAdapter>,
    private formBuilder: FormBuilder,
    private configUrlProvider: ConfigUrlProvider) {
    this.dateAdapter.setLocale('ptb');
    moment.locale('pt-BR');
    this.configApi = this.configUrlProvider.getConfigApi();
    this.loadConfig();
  }

  ngOnInit() {
    this.configuracoes = JSON.parse(localStorage.getItem('DadosConfiguracoes'));
    this.configuracoes.DATA_ULTIMO_ACESSO = this.datePipe.transform(this.configuracoes.DATA_ULTIMO_ACESSO, 'dd/MM/yyyy HH:mm:ss')
    this.pesquisar = { PesquisarPor: 1, CadastroInLoco: "T", Concluido: "T", Categoria: 1 };
    this.DADOS = {};
    this.DADOS2 = {};
    this.DADOSSIMULACAO = { Codigo: 0 };
    this.DADOSSIMULACAOESPONTANEA = { Codigo: 0 };
    this.DADOCONTRIB = { MES_INICIO: new Date().getMonth() + 1, ANO_INICIO: new Date().getFullYear(), MES_FIM: new Date().getMonth() + 1, ANO_FIM: new Date().getFullYear() };
    this.SENHA = {};
    this.FALE = {};
    this.EXPLICACAOREGRA = {};
    this.DADOSPESSOAIS = {};
    this.parametros = {};
    this.DADOHOLERITE = { MES: new Date().getMonth() + 1, ANO: new Date().getFullYear() };
    this.DADOSFICHA = { ANO: new Date().getFullYear() };
    this.DADOSRENDIMENTOS = { ANO: new Date().getFullYear() - 1 };
    this.PARAMETROS_AGENDAMENTO = {};
    this.RESUMO_AGENDAMENTO = {};
    this.AGENDAR_RECADASTRAMENTO = {};
    this.DADOS_CEDENTE_BOLETO = {};
    this.HABILITAR_AGENDAMENTO = false;
    this.BOLETOS_PORTAL = [];
    this.GetSegurados();

    
    this.Assunto();
    this.CarregarParametrosCalendario();
    this.MostrarResumoAgendamento();
    this.AdicionarEventoPrioridadeModal();
   
    this.GetParametros();
 

  }

  //#region Validar_notificação
  ValidarNotificacao() : Promise<boolean> {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {    
    this.http.post(this.sub + "ValidarNotificacao", JSON.stringify({      
      SEGURADO_ID: this.configuracoes.SEGURADO_ID
    }), options)
    .map((response) => response.json())
    .subscribe(
      result => {
        this.isValidaNotificacao = result;
        
        resolve(true);
      },
      error => {
        reject(false);
       }
    )
  });
  }

  ValidarNotificacaoCC(): Promise<boolean> {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
    this.http.post(this.sub + "ValidarNotificacaoCC", JSON.stringify({
       SEGURADO_ID: this.configuracoes.SEGURADO_ID 
    }), options)
    .map((response) => response.json())
    .subscribe(
      result => {
        this.isValidarCC = result;

        resolve(true);
      },
      error => { 
        reject(false);
      }
    )
  });
  }

  ValidarNotificacaoRendimento() : Promise<boolean> {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) =>{
    this.http.post(this.sub + "ValidarNotificacaoRendimento", JSON.stringify({
      SEGURADO_ID: this.configuracoes.SEGURADO_ID
    }), options)
    .map((response) => response.json())
    .subscribe(
      result => {
        this.isValidarRedimento = result;
        resolve(true);
      },
      error => { 
        reject(false);
      }
    )
  });
  }

//#endregion Validar_notificação
  
CarregarGridInicial(currentPage: number) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.sub + "GetProcesso", JSON.stringify({ SEGURADO_ID: this.configuracoes.SEGURADO_ID }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
          if (this.TotalRegistro == 0) {
            swal({
              title: "Atenção!",
              type: "error",
              text: "Nenhum processo encontrado"
            });
          }
        },
        error => {

        }
      );
  }

  public pageChanged(event: any): void {
    this.PaginaAtual = event;
    this.CarregarGridInicial(event);
  }

  public EditarClick() {
    this.CarregarGridInicial(1);
  }

  //#region simulacao
  public Simulacao() {
    this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.DADOSSIMULACAO.Codigo = 0;
    this.http.post(this.sub + "GetSimulacao", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.DADOS2 = data.Resultado[0];
          this.DADOS = this.DADOS2.Table[0];
          this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
          this.DADOS.DATA_ADM = this.datePipe.transform(this.DADOS.DATA_ADM, 'dd/MM/yyyy');
          this.DADOS.DATA_NASC = this.datePipe.transform(this.DADOS.DATA_NASC, 'dd/MM/yyyy');
        },
        error => {

        }
      );
  }

  public SimularSegurado(event: any) {
    this.ABONO_PERMANENCIA = "N";
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.sub + "SimularSegurado", JSON.stringify({ SEGURADO_ID: event, DATA_CALC: this.DADOS2.DATA_CALC, DATA_NASC: this.DADOS.DATA_NASC, IDADE: this.DADOS.IDADE, ABONO_PERMANENCIA: "N" }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAO = data;
          if (data.Codigo == 0) {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });
          }
          else {
            this.DADOSSIMULACAO.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
          }
        },
        error => {

        }
      );
  }
  public ResultadoSimulacao(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.sub + "GetResultadoSimulacao", JSON.stringify({ RESULTADO_SIMULACAO_ID: event.RESULTADO_SIMULACAO_ID, SIMULA_REQUISITO_ID: event.SIMULA_REQUISITO_ID, TmpCarreira: event.TmpCarreira, SIMULA_ABONO: this.ABONO_PERMANENCIA }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "ResultadoSimulacao.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  public ExplicacaoRegra(event: any) {
    this.EXPLICACAOREGRA = event;
    $("#ModalSimulacaoExplicao").show();
    $("#ModalSimulacao").hide();
  }
  public SairExplicacaoRegra() {
    $("#ModalSimulacaoExplicao").hide();
    $("#ModalSimulacao").show();
  }
  public SimularSeguradoAbono(event: any) {
    this.ABONO_PERMANENCIA = "S";
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.sub + "SimularSegurado", JSON.stringify({ SEGURADO_ID: event, DATA_CALC: this.DADOS2.DATA_CALC, DATA_NASC: this.DADOS.DATA_NASC, IDADE: this.DADOS.IDADE, ABONO_PERMANENCIA: "S" }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAO = data;
          if (data.Codigo == 0) {
            swal({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });
          }
          else {
            this.DADOSSIMULACAO.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
          }
        },
        error => {

        }
      );
  }
  //#endregion simulacao

  //#region simulacaoespontanea
  public ExplicacaoRegraExpontanea(event: any) {
    this.EXPLICACAOREGRAEXPONTANEA = event;
    $("#ModalSimulacaoExplicaoExpontanea").show();
    $("#ModalSimulacaoEspontanea").hide();
  }
  public SairExplicacaoRegraExpontanea() {
    $("#ModalSimulacaoExplicaoExpontanea").hide();
    $("#ModalSimulacaoEspontanea").show();
  }
  public SimulacaoEspontanea() {
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.sub + "GetSimulacaoEspontanea", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.DADOS2 = data.Resultado[0];
          this.DADOS = this.DADOS2.Table[0];
          this.DADOS.DATA_ADM = this.datePipe.transform(this.DADOS.DATA_ADM, 'dd/MM/yyyy');
          this.DADOS.DATA_NASC = this.datePipe.transform(this.DADOS.DATA_NASC, 'dd/MM/yyyy');
          this.DADOS.ESPECIAL = "N";
          this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
          this.DADOS.DATA_CALC = this.DADOS2.DATA_CALC;
        },
        error => {

        }
      );
  }

  public SimularEspontanea(event: any) {

    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(this.DADOS);
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.http.post(this.sub + "GetGerarSimulacaoEspontanea", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC, DATA_ADM: this.DADOS.DATA_ADM
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAOESPONTANEA = data;
          if (data.Codigo == 0) {
            swal({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });
          }
          else {
            this.DADOSSIMULACAOESPONTANEA.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
          }
        },
        error => {
          this.Mostrar = false;
        }
      )
  }

  //#endregion simulacaoespontanea 

  public Processos(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http.post(this.sub + "GetHistorico", JSON.stringify({ PROCESSO_ID: event }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "HistoricoProcesso.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        },
        error => {
          this.Mostrar = false;
        }
      );
  }

  AlterSenha() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    if (this.SENHA.NOVA !== this.SENHA.CONFIRMA) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
      });
    }
    else {
      this.http.post(this.sub + "GetTrocarSenha", JSON.stringify({ ATUAL: this.SENHA.ATUAL, NOVA: this.SENHA.NOVA, LOGIN: this.configuracoes.LOGIN, USR_LOGIN_ID: this.configuracoes.USR_LOGIN_ID }), options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            this.Mostrar = false;
            this.TotalRegistro = data.Total;
            if (this.TotalRegistro == 0) {
              swal({
                title: "Atenção!",
                type: "error",
                text: "Senha atual não confere!"
              });
            }
            else {
              swal({
                title: "Atenção!",
                type: "success",
                text: "Senha alterada com sucesso!"
              });
            }
          },
          error => {
            this.Mostrar = false;
          }
        );
    }

  }

  //#region faleconosco
  Assunto() {
    if (this.configuracoes.FONE_RESIDENCIAL != null)
      this.FALE.FONE_RESIDENCIAL = this.configuracoes.FONE_RESIDENCIAL;
    if (this.configuracoes.EMAIL1 != null)
      this.FALE.EMAIL1 = this.configuracoes.EMAIL1;
    this.UtilServico.Get("GetAssunto").subscribe(data => this.assunto = data, error => { });
  }
  setAssunto($event) {
    this.selectedAssuntoId = $event;
    for (var i = 0; i < this.assunto.length; i++) {
      if (this.assunto[i].ASSUNTO_ID == $event) {
        this.selectedAssunto = this.assunto[i].NOME;
      }
    }
  }

  FaleConosco() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.sub + "GetFaleConosco", JSON.stringify({
      ASSUNTO_ID: this.selectedAssuntoId, ASSUNTO_NOME: this.selectedAssunto, EMAIL1: this.FALE.EMAIL1,
      FONE_RESIDENCIAL: this.FALE.FONE_RESIDENCIAL, DSC_ASSUNTO: this.FALE.DSC_ASSUNTO, NOME: this.configuracoes.NOME,
      USR_LOGIN_ID: this.configuracoes.USR_LOGIN_ID, SEXO: this.configuracoes.SEXO
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.TotalRegistro = data.Total;
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "success",
            text: "Email encaminhado com sucesso!"
          });
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  //#endregion faleconosco

  //#region dadospessoais
  GetUf() {
    this.UtilServico.Get("GetUf").subscribe(
      data => {
        this.uf = data;
      },
      error => { }

    );
  }
  GetCidades() {
    this.UtilServico.Get("GetCidades/" + this.DADOSPESSOAIS.UF_NASCIMENTO).subscribe(
      data => {
        this.cidades = data;
      },
      error => { }

    );
  }
  GetSegurados() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.http.get(this.sub + "GetSegurados/" + this.configuracoes.PESSOA_ID, options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.segurados = data;
        },
        error => {

        }
      );
  }

  GetSeguradoInfo(event) {
    this.Mostrar = true;    
    this.UtilServico.Get("GetSeguradoInfo/" + event).subscribe(
      data => {
        localStorage.setItem('DadosConfiguracoes', JSON.stringify(data))
        this.configuracoes = data;
        this.configuracoes.DATA_ULTIMO_ACESSO = this.datePipe.transform(this.configuracoes.DATA_ULTIMO_ACESSO, 'dd/MM/yyyy HH:mm:ss')
        this.Mostrar = false;

        this.GetParametros();
      },
      error => { this.Mostrar = false; }
    );
  }
  GetNacionalidade() {
    this.UtilServico.Get("GetNacionalidade").subscribe(
      data => {
        this.nacionalidade = data;
      },
      error => { }

    );
  }
  GetRaca() {
    this.UtilServico.Get("GetRaca").subscribe(
      data => {
        this.raca = data;
      },
      error => { }

    );
  }

  Pessoas() {
    this.GetUf();
    this.GetNacionalidade();
    this.GetRaca();
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.sub + "GetPessoas", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSPESSOAIS = data.Resultado;
          this.DADOSPESSOAIS.DATA_NASC = this.datePipe.transform(this.DADOSPESSOAIS.DATA_NASC, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.RG_DT_EMISSAO = this.datePipe.transform(this.DADOSPESSOAIS.RG_DT_EMISSAO, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.CTPS_DT_EMISSAO = this.datePipe.transform(this.DADOSPESSOAIS.CTPS_DT_EMISSAO, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.UF_NASCIMENTO = data.UF;
          this.DADOSPESSOAIS.END_UF = data.END_UF;
          this.DADOSPESSOAIS.DEPENDENTES = data.DEPENDENTES;
          if (this.DADOSPESSOAIS.UF_NASCIMENTO != null)
            this.GetCidades();
          if (this.DADOSPESSOAIS.NACIONALIDADE_ID == null)
            this.DADOSPESSOAIS.NACIONALIDADE_ID = 25;
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  public SalvarPessoas() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(this.DADOSPESSOAIS);
    if (this.parametros.PORTAL_CADASTRO_DIRETO === "S") {
      this.http.put(this.sub + "PutPESSOAS/" + this.DADOSPESSOAIS.PESSOA_ID, body, options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            this.Mostrar = false;
            swal({
              title: "Atenção!",
              type: "success",
              text: "Cadastro atualizado com sucesso!"
            });
          },
          error => {
            this.Mostrar = false;
          }
        );
    }
    else {
      this.http.put(this.sub + "PutPESSOAS_TEMP/" + this.DADOSPESSOAIS.PESSOA_ID, body, options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            this.Mostrar = false;
            swal({
              title: "Atenção!",
              type: "success",
              text: "Cadastro atualizado com sucesso!"
            });
          },
          error => {
            this.Mostrar = false;
          }
        );
    }
  }
  //#endregion dadospessoais

  //region extratocontrib
  public EmitirExtrato() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.sub + "GetExtratoContrib", JSON.stringify({
      MES_INICIO: this.DADOCONTRIB.MES_INICIO, ANO_INICIO: this.DADOCONTRIB.ANO_INICIO,
      MES_FIM: this.DADOCONTRIB.MES_FIM, ANO_FIM: this.DADOCONTRIB.ANO_FIM, PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "ExtratoContribuicao.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion extratocontrib

  //#region holerite
  public EmitirHolerite() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http.post(this.sub + "GetHolerite", JSON.stringify({
      MES_INICIO: this.DADOHOLERITE.MES, ANO_INICIO: this.DADOHOLERITE.ANO,
      PESSOA_ID: this.configuracoes.PESSOA_ID, DECIMO: this.DADOHOLERITE.DECIMO,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "Holerite.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion holerite

  //#region fichafinanceira
  public EmitirFichaFinanceira() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.sub + "GetFichaFinanceira", JSON.stringify({
      ANO_INICIO: this.DADOSFICHA.ANO,
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "FichaFinanceira.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion fichafinanceira

  //region rendimentospagos
  public EmitirComprovanteRendimentos() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.sub + "ComprovanteRendimentos", JSON.stringify({
      ANO_INICIO: this.DADOSRENDIMENTOS.ANO,
      PESSOA_ID: this.configuracoes.PESSOA_ID, USR_LOGIN_ID: this.configuracoes.USR_LOGIN_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "ComprovanteRendimentosPagos.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion rendimentospados 

  //#region Perguntas Frequentes

  public Faq() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.sub + "GetFaq", JSON.stringify({
      CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      ORGAO_ID: this.configuracoes.ORGAO_ID,
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.FAQ = data;
        },
        error => {
          this.Mostrar = false;
        }
      );
  }

  //#endregion Perguntas Frequentes

  //#region Boleto Arrecadação

  public BoletoArrecadacao() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.sub + "GetBoletos", JSON.stringify({
      SEGURADO_ID: this.configuracoes.SEGURADO_ID
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.BOLETOS_PORTAL = data
        },
        error => {
          this.Mostrar = false;
        }
      )
      this.GetParametros()
      console.log(this.parametros)
  }

  EmitirBoletoArrecadacao(PARCELA_ID: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.sub + "GeraDadosBoleto", JSON.stringify({
      PARCELA_ID: PARCELA_ID,
      URL: this.subSisprev
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;

          if (this.isTypedArray(data) == true) {
            var file = new Blob([data], { type: 'application/pdf' });

            if (window.navigator.msSaveOrOpenBlob) //IE & Edge
            {
              //msSaveBlob only available for IE & Edge
              saveAs(file, "BoletoArrecadacao.pdf");
            }
            else {
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
            }
          }
          else {
            swal({
              title: "Atenção!",
              type: "error",
              text: data.MENSAGEM
            });
          }
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Não foi possível gerar o Boleto!"
          });
        }
      );
  }

  ParcelaEstaVencida(VENCIMENTO: any) {
    let dataAtual = new Date();
    let dataVENCIMENTO = new Date(VENCIMENTO);
    let parcelaVencida = true;
 
    if (dataVENCIMENTO > dataAtual) {
      parcelaVencida = false;
    }

    return parcelaVencida;

  }

  

  isTypedArray(obj: any) {
    return obj.type == 'application/pdf';
  }

  //#endregion Boleto Arrecadação

  //region Agendar Recadastramento


  // @ViewChild('calendar')
  calendar: MatCalendar<Moment>;
  filterDate: MatCalendar<Moment>;

  selectedDate: Moment;

  onDateChanged(date: any) {
    let dataSelecionada = this.datePipe.transform(date.value._d, 'dd/MM/yyyy');
    this.AGENDAR_RECADASTRAMENTO.DATA_AGENDAMENTO = dataSelecionada;
    this.AGENDAR_RECADASTRAMENTO.RECAD_LOCAL = this.PARAMETROS_AGENDAMENTO.RECAD_LOCAL;

    this.VerificarDataAgendamento(dataSelecionada);
  }

  public CarregarInformacoesRecadastramento() {
    this.CarregarParametrosCalendario();
  }


  public VerificarDataAgendamento(data: any) {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.sub + "VerificarDiponibilidadeData", JSON.stringify({
      DATA: data,
      ORGAO_ID: this.configuracoes.ORGAO_ID,
      TIPO_RECADASTRAMENTO: this.PARAMETROS_AGENDAMENTO.TIPO_RECADASTRAMENTO,
      MES_ANIVERSARIO: this.datePipe.transform(this.configuracoes.DATA_NASC, 'MM')
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.HABILITAR_AGENDAMENTO = data
        },
        error => {
          this.Mostrar = false;
        }
      )
  }

  CarregarParametrosCalendario() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.sub + "CarregarParametrosAgendamento", JSON.stringify({
      ORGAO_ID: this.configuracoes.ORGAO_ID,
      DATA_ANIVERSARIO: this.configuracoes.DATA_NASC
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.PARAMETROS_AGENDAMENTO.DISABLE_ALL_THESE_DAYS = data.DISABLE_ALL_THESE_DAYS;
          this.PARAMETROS_AGENDAMENTO.RECAD_LOCAL = data.RECAD_LOCAL;
          this.PARAMETROS_AGENDAMENTO.TIPO_RECADASTRAMENTO = data.TIPO_RECADASTRAMENTO;
          this.PARAMETROS_AGENDAMENTO.DATA_INICIAL = this.datePipe.transform(data.DATA_INICIAL, 'yyyy-MM-dd');
          this.PARAMETROS_AGENDAMENTO.DATA_INICIAL_MIN_DAY = data.DATA_INICIAL_MIN_DAY;
          this.PARAMETROS_AGENDAMENTO.DATA_INICIAL_MIN_MONTH = data.DATA_INICIAL_MIN_MONTH;
          this.PARAMETROS_AGENDAMENTO.DATA_INICIAL_MIN_YEAR = data.DATA_INICIAL_MIN_YEAR;
          this.PARAMETROS_AGENDAMENTO.DATA_FINAL = this.datePipe.transform(data.DATA_FINAL, 'yyyy-MM-dd');
          this.PARAMETROS_AGENDAMENTO.DATA_FINAL_MAX_DAY = data.DATA_FINAL_MAX_DAY;
          this.PARAMETROS_AGENDAMENTO.DATA_FINAL_MAX_MONTH = data.DATA_FINAL_MAX_MONTH;
          this.PARAMETROS_AGENDAMENTO.DATA_FINAL_MAX_YEAR = data.DATA_FINAL_MAX_YEAR;
        },
        error => {
          this.Mostrar = false;
        }
      );
  }

  SalvarAgendamento() {

    if (this.dadosRecadastramentoValidos() == false) {
      swal({
        title: "Atenção!",
        type: "warning",
        text: "Verifique se todos os campos foram preenchidos corretamente e tente novamente!"
      });

      return;
    }
    else {

      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
      let options = new RequestOptions({ headers: headers });

      this.http.post(this.sub + "SalvarAgendamento", JSON.stringify({
        SEGURADO_ID: this.configuracoes.SEGURADO_ID, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID, MATRICULA: this.configuracoes.SEGURADO_ID,
        NOME_USUARIO: this.configuracoes.NOME, LOGIN_USUARIO: this.configuracoes.LOGIN, USUARIO_ID: this.configuracoes.USR_LOGIN_ID,
        ORGAO_ID: this.configuracoes.ORGAO_ID, DATA_NASC: this.datePipe.transform(this.configuracoes.DATA_NASC, 'dd/MM/yyyy'),
        CPF: this.configuracoes.LOGIN,
        EMAIL: this.AGENDAR_RECADASTRAMENTO.EMAIL,
        TELEFONE: this.AGENDAR_RECADASTRAMENTO.TELEFONE,
        DECLARANTE: this.AGENDAR_RECADASTRAMENTO.DECLARANTE,
        PERIODO: this.AGENDAR_RECADASTRAMENTO.PERIODO,
        TIPO_RECADASTRAMENTO: this.PARAMETROS_AGENDAMENTO.TIPO_RECADASTRAMENTO,
        DATA_AGENDAMENTO: this.AGENDAR_RECADASTRAMENTO.DATA_AGENDAMENTO
      }), options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            if (data.SUCESSO == true) {
              this.EmitirProtocoloAgendameto(data.DADOS.ANO_AGENDAMENTO);
              this.FecharAgendamentoRecadastramento();
            }
            else {
              swal({
                title: "Atenção!",
                type: "error",
                text: data.MENSAGEM
              });
            }
          },
          error => {
            this.Mostrar = false;
            swal({
              title: "Atenção!",
              type: "error",
              text: "Não foi possível realizar agendamento!"
            });

            this.SairAgendamentoRecadastramento();
          })
    }
  }

  ExcluirProtocoloAgendamento() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.sub + "ExcluirProtocoloAgendamento", JSON.stringify({
      SEGURADO_ID: this.configuracoes.SEGURADO_ID,
      USUARIO_ID: this.configuracoes.USR_LOGIN_ID,
      ANO_AGENDAMENTO: this.RESUMO_AGENDAMENTO.ANO_AGENDAMENTO,
      RECAD_CONFIRMADO_ID: this.RESUMO_AGENDAMENTO.RECAD_CONFIRMADO_ID
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          if (data.SUCESSO == true) {
            this.Mostrar = false;
            swal({
              title: "Atenção!",
              type: "success",
              text: data.MENSAGEM
            });
          }
          else {
            swal({
              title: "Atenção!",
              type: "error",
              text: data.MENSAGEM
            });
          }
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Não foi possível excluir o agendamento!"
          });
        }
      );

    this.SairResumoAgendamento();
  }

  EmitirProtocoloAgendameto(ANO_AGENDAMENTO: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.sub + "EmitirProtocoloAgendamento", JSON.stringify({
      SEGURADO_ID: this.configuracoes.SEGURADO_ID,
      CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      ANO_AGENDAMENTO: ANO_AGENDAMENTO,
      MATRICULA: this.configuracoes.SEGURADO_ID,
      NOME_USUARIO: this.configuracoes.NOME,
      LOGIN_USUARIO: this.configuracoes.LOGIN, USUARIO_ID: this.configuracoes.USR_LOGIN_ID
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "ProtocoloAgendamento.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Não foi possível realizar emissão do protocolo de agendamento!"
          });
        })

    this.MostrarResumoAgendamento();
  }

  MostrarResumoAgendamento() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.sub + "MostrarResumoAgendamento", JSON.stringify({
      SEGURADO_ID: this.configuracoes.SEGURADO_ID,
      ORGAO_ID: this.configuracoes.ORGAO_ID,
      DATA_NASCIMENTO: this.datePipe.transform(this.configuracoes.DATA_NASC, 'dd/MM/yyyy'),
      CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.RESUMO_AGENDAMENTO.EXIBIR_RESUMO_AGENDAMENTO = data.EXIBIR_RESUMO_AGENDAMENTO;
          this.RESUMO_AGENDAMENTO.RECAD_CONFIRMADO_ID = data.RECAD_CONFIRMADO_ID;
          this.RESUMO_AGENDAMENTO.DATA = data.DATA;
          this.RESUMO_AGENDAMENTO.ANO_AGENDAMENTO = data.ANO_AGENDAMENTO;
          this.RESUMO_AGENDAMENTO.HORARIO = data.HORARIO;
          this.RESUMO_AGENDAMENTO.LOCAL = data.LOCAL;
          this.RESUMO_AGENDAMENTO.PERIODO = data.PERIODO;
        },
        error => {
        }
      );
  }

  dateFilter = (date: Date) => date.getMonth() == 7;

  public RealizarAgendamentoRecadastramento() {
    $("#ModalSalvarDadosAgendaRecadastramento").modal('show');
    $("#ModalAgendarRecadastramento").modal('hide');
  }
  public SairAgendamentoRecadastramento() {
    $("#ModalSalvarDadosAgendaRecadastramento").modal('hide');
    $("#ModalAgendarRecadastramento").modal('show');
  }

  public FecharAgendamentoRecadastramento() {
    $("#ModalSalvarDadosAgendaRecadastramento").modal('hide');
    $("#ModalAgendarRecadastramento").modal('hide');
  }

  private SairResumoAgendamento() {
    this.RESUMO_AGENDAMENTO.EXIBIR_RESUMO_AGENDAMENTO = false;
    $("#ModalResumoAgendamento").modal('hide');
  }

  private SairAgendamento() {
    $("#ModalSalvarDadosAgendaRecadastramento").modal('hide');
    $("#ModalAgendarRecadastramento").modal('hide');
  }

  ExibirCalendario() {

    let dataMinAno = this.PARAMETROS_AGENDAMENTO.DATA_INICIAL_MIN_YEAR;
    let dataMinMes = this.PARAMETROS_AGENDAMENTO.DATA_INICIAL_MIN_MONTH;
    let dataMinDia = this.PARAMETROS_AGENDAMENTO.DATA_INICIAL_MIN_DAY;
    let dataMaxAno = this.PARAMETROS_AGENDAMENTO.DATA_FINAL_MAX_YEAR;
    let dataMaxMes = this.PARAMETROS_AGENDAMENTO.DATA_FINAL_MAX_MONTH;
    let dataMaxDia = this.PARAMETROS_AGENDAMENTO.DATA_FINAL_MAX_DAY;

    this.minDate = new Date(dataMinAno, dataMinMes, dataMinDia);
    this.maxDate = new Date(dataMaxAno, dataMaxMes, dataMaxDia);
  }

  desabiltarFimSemanaDiasAnteriores = (d: Date): boolean => {
    const day = new Date(d).getDay();
    const dataAtual = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    const dataComparacao = this.datePipe.transform(new Date(d), 'dd/MM/yyyy');

    // Desabilitar sábado, domingo e datas menores que a data atual
    return (day !== 0 && day !== 6 && dataComparacao >= dataAtual);
  }

  dadosRecadastramentoValidos() {

    if (!this.propriedadeInvalida(this.AGENDAR_RECADASTRAMENTO.EMAIL) &&
      !this.propriedadeInvalida(this.AGENDAR_RECADASTRAMENTO.TELEFONE) &&
      !this.propriedadeInvalida(this.AGENDAR_RECADASTRAMENTO.DECLARANTE) &&
      !this.propriedadeInvalida(this.AGENDAR_RECADASTRAMENTO.PERIODO)) {
      return true;
    }

    return false;
  }

  propriedadeInvalida(value: any): boolean {
    return value === undefined || value === null
  }

  AdicionarEventoPrioridadeModal() {
    $('#ModalSalvarDadosAgendaRecadastramento').on('show.bs.modal', function () {
      var modS = $(this),
        modZ = 0;
      modS.each(function () {
        var zIdx = $(this).css('z-index');
        if (zIdx >= modZ) {
          modZ = parseInt(zIdx) + 1;
        }
      });
      $(this).css('z-index', modZ);
    });

    $('#ModalSalvarDadosAgendaRecadastramento').on('hide.bs.modal', function () {
      var modS = $(this),
        modZ = 0;
      modS.each(function () {
        var zIdx = $(this).css('z-index');
        if (zIdx >= modZ) {
          modZ = parseInt(zIdx) - 1;
        }
      });
      $(this).css('z-index', modZ);
    });
  }

  //#endregion Agendar Recadastramento

  //region parametros
  async GetParametros() {


    await this.ValidarNotificacao();
    await this.ValidarNotificacaoCC();
    await this.ValidarNotificacaoRendimento();

    this.UtilServico.Get("GetParametros/").subscribe(
      data => {
        this.parametros = data[0];

        //INICIO DA NOTIFICACAO DO CHAMDO 
        var validacc = this.isValidarCC
        var validarredimento = this.isValidarRedimento
        var ValidarNotificacao = this.isValidaNotificacao
        var html1 = "";
        var html = "";

        if (validacc) 
        {   
          if(this.parametros.AUTENTICACAO_ATIVA_CC == "S")
          { 
            if(ValidarNotificacao[0].TMP_NUMERO_REPETICOES_CC <=  this.parametros.NUMERO_REPETICOES_CC )
            { 
              html = data[0].NOTIFICACAO_CONTRACHEQUE;
            }
          }
        }
        if(validarredimento)
        {   
          if(this.parametros.AUTENTICACAO_ATIVA_RENDIMENTO == "S")
          { 
            if(ValidarNotificacao[0].TMP_NUMERO_REPETICOES_RENDIMENTO <= this.parametros.NUMERO_REPETICOES_RENDIMENTO )
            {   
                html1 =  data[0].NOTIFICACAO_RENDIMENTO; 
            }
          }
        }
       
        if (html != "" || html1 != "") 
        {   
            swalAlert.fire({
              title: "Atenção!",
              type: "warning",
              html: html + "<br>" + html1 ,
            });
        }
        //FIM 
      },
      error => { }
    );
  }

  private loadConfig() {
    this.sub = `${this.configApi.webApiUrl}/api/Inicial/`;
    this.subSisprev = `${this.configApi.urlSisprev}`;
  }

  //#endregion parametros    
}



// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/inicial/inicial.component.ts